import type { Portfolio } from '@/features/bidding/types/bid'
import { isSinglePriceStepPartner } from '@/features/bidding/utils/validation/priceStepValidationUtils'

export enum BiddingFlow {
  CAPACITY_FLOW = 'CAPACITY_FLOW',
  CAPACITY_AND_PRICE_FLOW = 'CAPACITY_AND_PRICE_FLOW',
}

const getBiddingFlow = (portfolio: Portfolio): BiddingFlow => {
  if (portfolio.countryCode.toLowerCase() === 'se' && isSinglePriceStepPartner(portfolio.partnerCode)) {
    return BiddingFlow.CAPACITY_AND_PRICE_FLOW
  }
  if (['fi', 'gr', 'no'].includes(portfolio.countryCode.toLowerCase())) {
    return BiddingFlow.CAPACITY_AND_PRICE_FLOW
  }
  return BiddingFlow.CAPACITY_FLOW
}

export default getBiddingFlow
